import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Plane, ArrowRight } from 'lucide-react';
import { api } from '../../context/AuthContext';

const fmt = (iso) => `${iso.slice(8, 10)}.${iso.slice(5, 7)}.`;

export const AbwesendKarte = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/urlaub/abwesend').then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (!d) return null;
  const heute = d.items.filter((x) => x.heute);
  const woche = d.items.filter((x) => !x.heute);
  const Zeile = ({ x }) => (
    <li className="flex flex-wrap items-center gap-x-3 gap-y-0.5 text-sm py-1.5" data-testid={`abwesend-${x.user_id}-${x.von}`}>
      <span className="font-medium text-[#1B3A5C] min-w-[130px]">{x.name}</span>
      <span className="tabular-nums text-gray-600">{fmt(x.von)} – {fmt(x.bis)}</span>
      <span className="text-xs text-gray-500">{x.art_label}</span>
      {x.vertretung_name && <span className="text-xs px-2 py-0.5 rounded-full bg-[#f5f8fa] border border-gray-200 text-[#1B3A5C]">Vertretung: {x.vertretung_name}</span>}
    </li>
  );
  return (
    <section className="bg-white border border-gray-200 rounded-2xl p-5" data-testid="abwesend-karte">
      <div className="flex items-center gap-2 mb-2">
        <Plane className="w-4 h-4 text-[#b8893d]" />
        <h2 className="text-base md:text-lg font-serif text-[#1B3A5C]">Abwesend</h2>
        <span className="text-xs text-gray-500">Woche {fmt(d.woche_von)} – {fmt(d.woche_bis)}</span>
        <Link to="/kanzlei/urlaub" className="ml-auto inline-flex items-center gap-1 text-xs text-[#b8893d]" data-testid="abwesend-zum-plan">Urlaubsplan <ArrowRight className="w-3 h-3" /></Link>
      </div>
      {!d.items.length ? <p className="text-sm text-gray-500" data-testid="abwesend-leer">Diese Woche sind alle im Büro.</p> : (
        <div className="grid md:grid-cols-2 gap-x-8">
          <div><div className="text-[10px] uppercase tracking-wider text-gray-500">Heute ({heute.length})</div><ul data-testid="abwesend-heute">{heute.length ? heute.map((x) => <Zeile key={`${x.quelle}-${x.user_id}-${x.von}`} x={x} />) : <li className="text-xs text-gray-400 py-1.5">Niemand</li>}</ul></div>
          <div><div className="text-[10px] uppercase tracking-wider text-gray-500">Weitere diese Woche ({woche.length})</div><ul data-testid="abwesend-woche">{woche.length ? woche.map((x) => <Zeile key={`${x.quelle}-${x.user_id}-${x.von}`} x={x} />) : <li className="text-xs text-gray-400 py-1.5">Niemand</li>}</ul></div>
        </div>
      )}
    </section>
  );
};
